import type { SerializableValue } from '../serializable';

export type DataContractValue = SerializableValue;

export type DataPath = string;
